export default "__VITE_ASSET__BeXrqsU4__"